import mapService from "./mapService";

const Services = {
  mapService: mapService
};

export default Services;
